import { render, staticRenderFns } from "./EditController.vue?vue&type=template&id=d32ef806&scoped=true"
import script from "./EditController.vue?vue&type=script&lang=js"
export * from "./EditController.vue?vue&type=script&lang=js"
import style0 from "./EditController.vue?vue&type=style&index=0&id=d32ef806&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32ef806",
  null
  
)

export default component.exports